export const ROUTES = {
  ROOT: '',
  AUTH: 'auth',
  LOGIN: 'login',
  ADMIN: 'admin',
  LEARNER: 'learner',
  LEARNERS: 'learners',
  HR: 'hr',
  MARKETING: 'marketing',
  SYSTEM: 'system',
  NOTFOUND: 'notfound',
  NOACCESS: 'noaccess'
};

export const FULL_ROUTES = {
  LOGIN: `/${ROUTES.AUTH}/${ROUTES.LOGIN}`,
  ADMIN: `/${ROUTES.ADMIN}`,
  LEARNER: `/${ROUTES.LEARNER}`,
  LEARNERS: `/${ROUTES.LEARNERS}`,
  HR: `/${ROUTES.HR}`,
  MARKETING: `/${ROUTES.MARKETING}`,
  SYSTEM: `/${ROUTES.SYSTEM}`,
  NOTFOUND: `/${ROUTES.NOTFOUND}`,
  NOACCESS: `/${ROUTES.NOACCESS}`
};
